{
  "name": "utisha-frontend",
  "version": "2.0.29",
  "scripts": {
    "preinstall": "npm run co:login",
    "inject-version-in-index-html": "node lib/inject-version-in-index-html.js",
    "co:login": "aws codeartifact login --tool npm --repository utisha --domain utisha",
    "oas:utisha-api-client": "node ./lib/clean-generated.js utisha-backend && openapi-generator-cli generate -i src/app/api/utisha-api.json -g typescript-angular -o src/app/api/generated/utisha-backend --skip-validate-spec --additional-properties=\\\"configurationPrefix=UtishaBackend,ngVersion=14.0.0\\\"",
    "generate-apis": "npm run oas:utisha-api-client",
    "start": "ng serve --port 4201 --host 0.0.0.0 --public-host localhost.lambdatest.com --disable-host-check",
    "start-dev-tunnel": "ng serve --port 4201 --host 0.0.0.0 --public-host dev.utisha.com --disable-host-check",
    "start-ssl": "ng serve --ssl --host 0.0.0.0 --public-host DESKTOP-OSPT6RH",
    "profile": "ng build --stats-json && npx webpack-bundle-analyzer ./build/bundle-stats.json",
    "build": "ng build",
    "build-prod": "npm run generate-apis && ng build --configuration production && npm run sentry:sourcemaps",
    "start-prod": "ws -p 4200 --rewrite \"/api/(.*) -> http://localhost:8080/$1\"",
    "test": "ng test",
    "playwright:install": "npx playwright install --with-deps",
    "test:session-e2e": "npx playwright test -c tests/playwright/playwright.config.js",
    "compose:build": "docker compose build backend",
    "compose:up": "docker compose up -d --wait backend",
    "compose:down": "docker compose down",
    "compose:logs": "docker compose logs -f backend",
    "lint": "ng lint",
    "start-sw": "http-server -p 4200 -c-1 dist/utisha-frontend",
    "e2e": "ng e2e",
    "cap:sync": "ng build && npx cap sync",
    "cap:android": "npm run cap:sync && npx cap open android",
    "cap:ios": "npm run cap:sync && npx cap open ios",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org fides-it --project utisha-frontend ./dist/utisha-frontend && sentry-cli sourcemaps upload --org fides-it --project utisha-frontend ./dist/utisha-frontend"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.8",
    "@angular/cdk": "^21.2.6",
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/platform-browser": "^21.2.8",
    "@angular/platform-browser-dynamic": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@angular/service-worker": "^21.2.8",
    "@aws-amplify/auth": "^6.19.1",
    "@aws-amplify/core": "^6.16.1",
    "@aws-sdk/client-cognito-identity": "^3.451.0",
    "@aws-sdk/client-s3": "^3.451.0",
    "@aws-sdk/credential-provider-cognito-identity": "^3.451.0",
    "@aws-sdk/credential-providers": "^3.451.0",
    "@capacitor/android": "^8.3.1",
    "@capacitor/browser": "^8.0.3",
    "@capacitor/cli": "^8.3.1",
    "@capacitor/core": "^8.3.1",
    "@capacitor/ios": "^8.3.1",
    "@ctrl/tinycolor": "^4.2.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/angular": "^10.48.0",
    "@sentry/cli": "^3.3.5",
    "@stream-io/audio-filters-web": "^0.7.3",
    "@stream-io/video-client": "^1.46.1",
    "@stripe/stripe-js": "^9.1.0",
    "@tinymce/tinymce-angular": "^7.0.0",
    "@types/file-saver": "^2.0.7",
    "balloon-css": "^1.2.0",
    "cookieconsent": "^3.1.1",
    "file-saver": "^2.0.5",
    "flag-icons": "^7.5.0",
    "ios-webkit-debug-proxy": "0.0.3",
    "js-cookie": "^3.0.5",
    "localforage": "^1.10.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.6.1",
    "ng-zorro-antd": "^21.2.1",
    "ngx-cookieconsent": "^8.0.0",
    "ngx-scrollbar": "^19.1.4",
    "rxjs": "^7.4.0",
    "timesync": "~1.0.11",
    "tinymce": "^5.10.2",
    "tslib": "^2.0.0",
    "ua-parser-js": "^2.0.9",
    "zone.js": "~0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "@openapitools/openapi-generator-cli": "^2.7.0",
    "@playwright/test": "^1.44.0",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.3",
    "@types/js-cookie": "^3.0.6",
    "@types/node": "^22.15.3",
    "@types/offscreencanvas": "^2019.7.3",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/parser": "^5.62.0",
    "concurrently": "^8.2.2",
    "eslint": "^8.57.0",
    "express": "^4.21.2",
    "express-http-proxy": "^2.1.1",
    "http-proxy-middleware": "^3.0.3",
    "jasmine-core": "^6.2.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "patch-package": "^8.0.0",
    "ts-node": "^10.9.2",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
